module.exports = __webpack_public_path__ + "img/131.fe682caf.png";